import {
  GET_DYNAMIC_COLUMN_FAILURE,
  GET_DYNAMIC_COLUMN_REQUEST,
  GET_DYNAMIC_COLUMN_SUCCESS,
} from "./dynamicColumnTypes";

const initialStateForGetDynamicColumn = {
  loading: false,
  dynamicColumn: [],
  error: "",
};

const getDynamicColumnReducer = (
  state = initialStateForGetDynamicColumn,
  action
) => {
  switch (action.type) {
    case GET_DYNAMIC_COLUMN_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case GET_DYNAMIC_COLUMN_SUCCESS:
      return {
        loading: false,
        dynamicColumn: action.payload,
        error: "",
      };
    case GET_DYNAMIC_COLUMN_FAILURE:
      return {
        loading: false,
        dynamicColumn: [],
        error: action.payload,
      };
    default:
      return state;
  }
};

export { getDynamicColumnReducer };
